<template>
  <div ref="cell" class="grid-view__cell">
    <client-only>
      <div class="grid-field-date">
        <div
          ref="dateDisplay"
          class="grid-field-date__date"
          :class="{
            'grid-field-date--overdue': overdue && !done,
            'grid-field-date--done': done,
          }"
        >
          {{ getDate(field, value) || value }}
        </div>
        <div
          v-if="field.date_include_time"
          ref="timeDisplay"
          class="grid-field-date__time"
          :class="{
            'grid-field-date--overdue': overdue && !done,
            'grid-field-date--done': done,
          }"
        >
          {{ getTime(field, value) }}
        </div>
        <div v-if="field.date_show_tzinfo" class="grid-field-date__tzinfo">
          {{ getCellTimezoneAbbr(field, value) }}
        </div>
      </div>
    </client-only>
  </div>
</template>

<script>
import readOnlyDateField from '@baserow/modules/database/mixins/readOnlyDateField'
import {
  isDueDateOverdue,
  isRowDone,
} from '@baserow/modules/database/utils/dueDate'

export default {
  name: 'FunctionalGridViewFieldDate',
  mixins: [readOnlyDateField],
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    row: {
      type: Object,
      required: false,
      default: null,
    },
  },
  computed: {
    overdue() {
      return isDueDateOverdue(this.field, this.value)
    },
    // Linha concluída/cancelada: datas em verde (padrão ClickUp).
    done() {
      return (
        !!this.value && isRowDone(this.row, this.$store.getters['field/getAll'])
      )
    },
  },
}
</script>
